var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeditiation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_12472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.744 22.7755H28.0734C27.8592 22.7755 27.6579 22.673 27.5319 22.4998L23.7749 17.336C23.4746 16.9432 23.0084 16.7127 22.514 16.7127H21.6879C21.5095 16.7127 21.3648 16.568 21.3648 16.3896V15.6241C21.3648 15.473 21.4421 15.3333 21.5684 15.2503C22.3539 14.7343 22.8695 13.8412 22.8576 12.8284C22.8394 11.2688 21.5494 10.0007 19.9897 10.0078C18.4192 10.0151 17.1483 11.2904 17.1483 12.8626C17.1483 13.8608 17.6607 14.7393 18.4368 15.2496C18.5634 15.3329 18.6414 15.4727 18.6414 15.6243V16.3896C18.6414 16.568 18.4967 16.7127 18.3182 16.7127H17.2731C16.7786 16.7127 16.3124 16.9432 16.0122 17.336L12.2611 22.5412C12.1353 22.7159 11.9331 22.8194 11.7178 22.8194H11.2559C10.5623 22.8194 10 23.3817 10 24.0754C10 24.769 10.5623 25.3313 11.2559 25.3313H12.4897C11.7285 25.7566 11.2135 26.5698 11.2135 27.5037C11.2135 28.8773 12.3271 29.9909 13.7007 29.9909H24.2376L15.9601 25.4044C15.3021 25.1492 14.6011 25.0165 13.8917 25.0165H13.8429C13.9401 24.9388 14.0282 24.8485 14.1037 24.7461L16.4886 21.1947V24.325C16.5002 24.3305 16.5118 24.3357 16.5232 24.342L20.0281 26.2845L23.2985 24.3226V21.1947L25.6895 24.7022C25.7684 24.8093 25.861 24.9032 25.9635 24.9831C25.0593 24.9966 24.1044 25.2451 23.2985 25.6927V25.6887L21.2118 26.9406L26.5674 29.9089C27.7108 29.6847 28.5736 28.6776 28.5736 27.4686V27.4566C28.5736 26.5185 28.054 25.7075 27.2871 25.2874H28.7441C29.4377 25.2874 30 24.7252 30 24.0315C30 23.3378 29.4377 22.7755 28.744 22.7755Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_12472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditiation);
export default __webpack_public_path__ + "static/media/meditiation.634615461a227741a6978165b261db2e.svg";
export { ForwardRef as ReactComponent };